(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pagebuilder-featured-product"] && !Shopify.designMode) return;
  try {
    
  const qtyElementsList = document.querySelectorAll('.js-qty-select-field');

  // handle add-to-cart-form input
  // update order values function
  const onQuantityChange = function (button, el) {
    const qtyField = el.querySelector('.js-quantity-field');
    const btnMinus = el.querySelector('button.minus');
    const qtyTag = el.querySelector('span.js-quantity-text');
    let orderQty = qtyField.value;

    // depending on which button is clicked increase or decrease value
    if (button.className.indexOf('plus') != -1) {
      orderQty++;
    } else if (button.className.indexOf('minus') != -1) {
      orderQty--;
    }

    // set the order amount value for the hidden input field
    qtyField.value = orderQty;

    // disable minus button when 0 is reached
    orderQty > 1 ? (btnMinus.disabled = false) : (btnMinus.disabled = true);

    // update visible order amount
    qtyTag.innerHTML = orderQty;
  };

  // add eventlistener to all qty change buttons on the page
  qtyElementsList.forEach((el) => {
    const qtyChangeTags = el.querySelectorAll('.js-quantity-field-button');

    qtyChangeTags.forEach((button) => {
      button.addEventListener('click', () => {
        onQuantityChange(button, el);
      });
    });
  });

  // reset the input qty values on page load
  const resetOrderQty = () => {
    qtyElementsList.forEach((el) => {
      const qtyField = el.querySelector('.js-quantity-field');
      const qtyTag = el.querySelector('span.js-quantity-text');

      qtyField.value = 1;
      qtyTag.innerHTML = 1;
    });
  };

  resetOrderQty();

  } catch(e) { console.error(e); }
})();
})();
